<template>
    <div>
        <div class="EmptyDiv" v-if="PHQuestionData.length == 0">
            <img src="@/assets/svg/empty.svg" class="EmptyIcno">
            <p class="EmptyLabel">{{ i18n.$t('BBSQASearchEmpty') }}</p>
        </div>
        <div class="PHQuestionTableDiv" v-if="PHQuestionData.length != 0">
            <table>
                <tr>
                    <th class="PHQuestionTableSubjectTh">{{ i18n.$t('PHQuestionTabelTitle') }}</th>
                    <th class="PHQuestionTableTimeTh">{{ i18n.$t('PHQuestionTabelTime') }}</th>
                    <th class="PHQuestionTableReplyTh">{{ i18n.$t('PHQuestionTabelReply') }}</th>
                    <th class="PHQuestionTableOperateTh">{{ i18n.$t('PHQuestionTabelOperation') }}</th>
                </tr>
                <tr v-for="(item,index) in PHQuestionData" :key="item.id">
                    <td class="PHQuestionTableSubjectTd"><label class="PHQuestionTableSubjectTdLabel">{{ item.title }}</label></td>
                    <td class="PHQuestionTableTimeTd">{{ item.createTime }}</td>
                    <td class="PHQuestionTableReplyTd">{{ item.ascount }}</td>
                    <td class="PHQuestionTableOperateTd">
                        <label class="PHQuestionTableEdit" @click="EditPHQuestion(item.id)">{{ i18n.$t('PHQuestionTabelEdit') }}</label>
                        <a-popconfirm
                            title="Sure to delete?"
                            @confirm="DeletePHQuestion(item.id,index)"
                        >
                            <label class="PHQuestionTableDelete">{{ i18n.$t('PHQuestionTabelDelete') }}</label>
                        </a-popconfirm>
                    </td>
                </tr>
            </table>
            <a-pagination
                style="margin-right:35px;padding:15px 0px;"
                :current="currentPage"
                :pageSize="pageSize"
                :total="Total"
                @change="changePage"
            />
        </div>
    </div>
</template>

<script>
    import { useI18n } from "@/i18nPlugin";
    import { defineComponent, ref, } from "vue";
    import { useRouter } from 'vue-router';
    import { 
        SearchPHQuestionData,
        DeletePHQuestionData
        // EditPHQuestionData,
        // DeletePHQuestionData
    } from '../../api/index';
    export default defineComponent({
        setup() {
            const i18n = useI18n();
            const router = useRouter();
            const token = localStorage.getItem("userToken");
            const currentPage = ref(1);
            const pageSize = ref(10);
            const Total = ref(0);
            let PHQuestionData =  ref([]);
            const SearchPHQuestion = (pageSize,currentPage) => {
                SearchPHQuestionData ({
                    pageSize: pageSize,
                    currentPage: currentPage
                },token).then(res => {
                    Total.value = res.total;
                    PHQuestionData.value = res.data;
                }).catch(error => console.log(error));
            };
            const changePage = (page, pageSize) => {
                // console.log('page', page);
                currentPage.value = page
                // console.log('pageSize', pageSize);
                SearchPHQuestion(pageSize,page);
            };

            const EditPHQuestion= (id) => {
                router.push({ path: '/ATS/BBSEdit', query: { id: id }})
            }

            const DeletePHQuestion= (id,index) => {
                DeletePHQuestionData ({
                    id: id
                },token).then(res => {
                    if(res.status == 200) {
                        PHQuestionData.value.splice(index,1);
                    }
                    // console.log(res);
                }).catch(error => console.log(error));
            }
            
            return {
                i18n,
                token,
                currentPage,
                pageSize,
                Total,
                changePage,
                SearchPHQuestion,
                DeletePHQuestion,
                EditPHQuestion,
                PHQuestionData,
            }
        },
        mounted() {
            this.SearchPHQuestion(this.pageSize,this.currentPage);
        },
    })
</script>

<style scoped>
    .PHQuestionTableDiv {
        margin-left: 30px;
        margin-top: 32px;
    }
    .PHQuestionTableSubjectTh {
        width: 500px;
        height: 40px;
        font-size: 14px;
        color: #353535;
        text-align: left;
    }
    .PHQuestionTableSubjectTdLabel {
        cursor: pointer; 
        overflow: hidden;
        text-align: left;
        display: -webkit-inline-box;
        width: 500px;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .PHQuestionTableTimeTh {
        width: 250px;
        height: 40px;
        text-align: center;
        font-size: 14px;
        color: #353535;
    }
    .PHQuestionTableReplyTh {
        width: 150px;
        height: 40px;
        font-size: 14px;
        color: #353535;
        text-align: center;
    }
    .PHQuestionTableOperateTh {
        width: 150px;
        height: 40px;
        font-size: 14px;
        color: #353535;
        text-align: center;
    }
    .PHQuestionTableSubjectTd {
        height: 64px;
        font-size: 14px;
        color: #353535;
        border-bottom:  1px solid #D8D8D8;
    }
    .PHQuestionTableTimeTd {
        height: 64px;
        font-size: 14px;
        color: rgba(53,53,53,0.80);
        border-bottom:  1px solid #D8D8D8;
        text-align: center;
    }
    .PHQuestionTableReplyTd {
        height: 64px;
        font-size: 14px;
        color: rgba(53,53,53,0.80);
        border-bottom:  1px solid #D8D8D8;
        text-align: center;
    }
    .PHQuestionTableOperateTd {
        height: 64px;
        font-size: 14px;
        color: rgba(53,53,53,0.80);
        border-bottom:  1px solid #D8D8D8;
        text-align: center;
    }
    .PHQuestionTableEdit {
        font-size: 14px;
        color: #03a0d6;
        padding: 0 5px;
        letter-spacing: 0;
        cursor: pointer;
    }
    .PHQuestionTableDelete {
        font-size: 14px;
        color: #03a0d6;
        padding: 0 5px;
        letter-spacing: 0;
        cursor: pointer;
    }
    .EmptyDiv {
        text-align: center;
        padding: 100px 0;
    }
    .EmptyIcno {
        width: 200px;
        height: 66px;
    }
    .EmptyLabel {
        font-size: 14px;
        color: #BBBBBB;
    }
</style>